import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { scrollToForm } from '../utils/scroll';
const options = [{
  label: 'Presencial',
  place: 'Doral, Florida',
  text: 'Conoce este camino personalmente.'
}, {
  label: 'Zoom',
  place: 'Donde estés',
  text: 'Conéctate desde donde estés.'
}];
export function Conversemos() {
  return <section className="w-full bg-ivory py-24 sm:py-32 lg:py-40" aria-labelledby="talk-title" data-id="element-29" data-mp="3g7r54hf9vlx1">
      <div className="mx-auto max-w-page px-5 sm:px-10 lg:px-12" data-id="element-30" data-mp="3ba7jgwg8w6v2">
        <Reveal data-id="element-31" data-mp="3p8p24framt64">
          <h2 id="talk-title" className="font-sans text-[2rem] font-light uppercase leading-[1.08] text-ink sm:text-5xl xl:text-[3.4rem]" data-id="element-32" data-mp="3p9gvdjxf4et8">
            Conversemos.
          </h2>
          <p className="mt-6 font-serif text-2xl italic text-champagne sm:text-3xl" data-id="element-33" data-mp="14jrjnfs0h94r">
            ¿Quieres conocer mejor cómo funciona?
          </p>
          <p className="mt-7 max-w-xl font-sans text-[17px] font-light leading-relaxed text-steel sm:text-lg" data-id="element-34" data-mp="3tlclw9oucttf">
            Déjanos tus datos y una persona de nuestro equipo se pondrá en
            contacto contigo para coordinar una conversación.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-x-20 border-t border-ink/15 sm:mt-16 md:grid-cols-2" data-id="element-35" data-mp="bepvul29xikw">
          {options.map((option, i) => <Reveal key={option.label} delay={i * 0.08} className="border-b border-ink/12" data-id="element-36" data-mp="39y6lsawcwwbf" data-mpi={i}>
              <div className="py-9 sm:py-11" data-id="element-37" data-mp="3jv1katsmqwpp">
                <h3 className="font-sans text-lg font-medium uppercase tracking-[0.2em] text-ink sm:text-xl" data-id="element-38" data-mp="3jt6x18tvysig">
                  {option.label}
                </h3>
                <p className="mt-3 font-sans text-[13px] font-medium uppercase tracking-[0.16em] text-champagne" data-id="element-39" data-mp="2r6m8eg4souil">
                  {option.place}
                </p>
                <p className="mt-4 max-w-sm font-sans text-base font-light leading-relaxed text-steel sm:text-[17px]" data-id="element-40" data-mp="2w2ufr7cr3jf7">
                  {option.text}
                </p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={0.1} data-id="element-41" data-mp="2xukfi0nahq6u">
          <CtaButton label="Agendar una conversación" tone="ink" className="mt-12 w-full sm:w-auto" data-id="element-42" data-mp="2xtsutkv8dcvc" />
        </Reveal>

        <Reveal delay={0.14} data-id="element-43" data-mp="2sxaucx6xo0ot">
          <div className="mt-14 border-t border-ink/12 pt-8" data-id="element-44" data-mp="255dhr3vnt4mn">
            <h3 className="font-sans text-[12px] font-medium uppercase tracking-[0.18em] text-steel" data-id="element-45" data-mp="255x0unx1pz29">
              ¿Aún no estás seguro/a?
            </h3>
            <p className="mt-4 max-w-lg font-sans text-base font-light leading-relaxed text-steel" data-id="element-46" data-mp="2f430szzakv4h">
              También puedes dejarnos tus datos y conversar primero con una
              persona de nuestro equipo.
            </p>
            <button type="button" onClick={scrollToForm} className="group mt-6 inline-flex items-center gap-2 border-b border-ink/25 pb-1 font-sans text-[11px] font-medium uppercase tracking-[0.18em] text-ink transition-colors duration-200 ease-out hover:border-champagne hover:text-steel" data-id="element-47" data-mp="3qhf0cyo0qrku">
              Agendar conversación
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-48" data-mp="ycr3w6frjtdj" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>;
}